import {
  Box,
  Grid,
  Dialog,
  Button,
  IconButton,
  DialogActions,
} from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { ThumbUpload } from 'components/ThumbUpload';
import { Table } from 'components/Table';
import { Fields } from 'components/Fields';
import { getImageURL } from 'utils/tableListFormat';
import { Controller } from 'react-hook-form';
import {
  SerieTitle,
  VideoTitle,
} from 'components/TableWithCheck/VideoOrSerieModal/Title';
import { useFormModal } from './useFormModal';

export const FormModal = ({ data, open, onClose }) => {
  const {
    control,
    loading,
    initialTitle,
    onSubmit,
    handleSubmit,
    onChangeImage,
  } = useFormModal({
    data,
    onClose,
  });

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      data-no-dnd="true"
      open={open}
      onClose={() => {
        !loading && onClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <IconButton
        aria-label="close modal"
        sx={{
          justifySelf: 'end',
          position: 'absolute',
          right: '10px',
          top: '10px',
        }}
        onClick={onClose}
        disabled={loading}>
        <CloseOutlined />
      </IconButton>
      <Table.Title>
        {data.type === 'VIDEO' ? (
          <VideoTitle title="Editar Conteúdo: " name={initialTitle} />
        ) : (
          <SerieTitle title="Editar Conteúdo: " name={initialTitle} />
        )}
      </Table.Title>
      <Box data-no-dnd="true" padding={2}>
        <Grid container spacing={2}>
          <Grid
            item
            xs
            sx={{
              display: 'grid',
              gridTemplateColumns: 'auto',
              gap: 2,
            }}>
            <Controller
              name="title"
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState: { error, isTouched } }) => (
                <Fields.TextLength
                  label="Título"
                  readOnly
                  maxLength={72}
                  error={isTouched && !!error}
                  helperText={isTouched && error ? 'Campo obrigatório' : ''}
                  {...field}
                />
              )}
            />

            <Controller
              name="description"
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState: { error, isTouched } }) => (
                <Fields.TextLength
                  label="Descrição"
                  endAdornment="140 carac."
                  maxLength={140}
                  error={isTouched && !!error}
                  helperText={isTouched && error ? 'Campo obrigatório' : ''}
                  {...field}
                />
              )}
            />

            <Controller
              name="transitionMiliseconds"
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState: { error, isTouched } }) => (
                <Fields.Number
                  label="Velocidade de Transição (ms)"
                  sx={{
                    maxWidth: 194,
                  }}
                  maxLength={5}
                  error={isTouched && !!error}
                  helperText={isTouched && error ? 'Campo obrigatório' : ''}
                  {...field}
                  onChange={({ target }) =>
                    field.onChange(Number(target.value))
                  }
                />
              )}
            />
          </Grid>
          <Grid
            item
            sx={{
              display: 'grid',
              alignItems: 'end',
            }}>
            <ThumbUpload
              loading={loading}
              image={getImageURL(data)}
              onChange={onChangeImage}
            />
          </Grid>
        </Grid>
      </Box>
      <DialogActions>
        <Button
          variant="outlined"
          disabled={loading}
          sx={{
            width: 89,
          }}
          onClick={onClose}>
          Sair
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit(onSubmit)}
          disabled={loading}
          autoFocus
          sx={{
            width: 108,
          }}>
          Alterar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
